import React from 'react';
import { printCurrency } from '../util/formatUtility';
import { translateResourceString } from '../util/translationUtility';

class Item extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    handleSelected = (event) => {
        this.props.setSelected(this.props.item.Code, event.target.checked);
    }

    handleQuantityChange = (event) => {
        let val = event.target.value.replace(/[^0-9]/g, '');
        if (val === this.props.quantity) return false;
        this.props.setQuantity(this.props.item.Code, val);
    }

    handleOnBlur = (event) => {
        let val = event.target.value.replace(/[^0-9]/g, '');
        if (!val) val = 0;
        if (val === this.props.quantity) return false;
        this.props.setQuantity(this.props.item.Code, Number(val));
    }

    render() {
        const {
            item
        } = this.props;

        const quantity = isNaN(item.quantity) ? 0 : item.quantity;
        const total = quantity * item.UnitPrice;

        return (
            <tr>
                <td className="input-container" style={{ verticalAlign: "middle" }}>
                    {!item.VariantStatusLongDescription && <input type="checkbox" checked={item.isSelected} onChange={this.handleSelected} />}</td>
                <td>
                    <div className="row no-gutters">
                        <div className="col-auto">
                            <a href={item.Url} title={item.DisplayName} style={{ maxWidth: '150px' }}>
                                <img src={item.ImageUrl} alt={item.DisplayName} className="mr-3" style={{ maxWidth: '150px' }} />
                            </a>
                        </div>
                        <div className="col">
                            <a href={item.Url}>
                                <h4>
                                    {item.DisplayName} <br/>
                                    ({item.Code})
                                </h4>
                            </a>
                            <span className="fw-600">{printCurrency(item.UnitPrice)}</span><br/>
                            {item.VariantStatusLongDescription && 
                                <div class="variant-status-hint-wrapper bg-light-gray">
                                    <i class="fas fa-exclamation-circle mr-1 color-red"></i>
                                    <span class="variant-status-hint">{item.VariantStatusLongDescription}</span>
                                </div>
                            }
                        </div>
                    </div>
                </td>
                <td>
                    {!!item.LastPurchaseDate && <>
                        {item.LastPurchaseDate}<br />
                        {translateResourceString("/MyAccountPage/MyItems/OrderNumberLabel", item.LastPurchaseOrderNumber)}
                    </>
                    }
                </td>
                    <td className="input-container">
                        {!item.VariantStatusLongDescription && <input type="text" className="form-control text-right" value={quantity} maxLength="5"
                            onChange={this.handleQuantityChange} onBlur={this.handleOnBlur} />}
                    </td>
                <td className="text-right">{printCurrency(total)}</td>
            </tr>
        );
    }
}

export default Item;